import styled from '@emotion/styled';
import { Variables } from '../base/variables';

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    padding: 24px;
    // background-color: ${Variables.Colors.n15};
    @media (max-width: 768px) {
        padding: 16px;
    }

    @media (max-width: 480px) {
        padding: 12px;
    }
`;

export const Header = styled.div`
    margin-bottom: 32px;

    @media (max-width: 768px) {
        margin-bottom: 24px;
    }

    @media (max-width: 480px) {
        margin-bottom: 16px;
    }
`;

export const ClaimValidationBanner = styled.div`
    margin-bottom: 16px;

    & > div {
        margin-bottom: 0;
    }
`;

export const Title = styled.h1`
    font-size: 32px;
    font-weight: 600;
    color: ${Variables.Colors.n100};
    margin: 0;

    @media (max-width: 768px) {
        font-size: 24px;
    }

    @media (max-width: 480px) {
        font-size: 20px;
    }
`;

export const Content = styled.div`
    display: flex;
    flex-direction: column;
    gap: 24px;
    background-color: ${Variables.Colors.white};
    border-radius: 8px;
    padding: 24px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);

    @media (max-width: 768px) {
        padding: 16px;
        gap: 16px;
        border-radius: 6px;
    }

    @media (max-width: 480px) {
        padding: 12px;
        gap: 12px;
        border-radius: 4px;
    }
`;

export const Section = styled.div`
    padding: 16px;
    border: 1px dashed ${Variables.Colors.nx8};
    border-radius: 4px;
    background-color: ${Variables.Colors.n15_24};

    @media (max-width: 768px) {
        padding: 12px;
    }

    @media (max-width: 480px) {
        padding: 10px;
    }
`;

export const SectionTitle = styled.h2`
    font-size: 18px;
    font-weight: 500;
    color: ${Variables.Colors.n70};
    margin: 0 0 8px 0;

    @media (max-width: 768px) {
        font-size: 16px;
        margin: 0 0 6px 0;
    }

    @media (max-width: 480px) {
        font-size: 14px;
        margin: 0 0 4px 0;
    }
`;

export const SectionPlaceholder = styled.p`
    font-size: 14px;
    color: ${Variables.Colors.n50};
    margin: 0;
    font-style: italic;

    @media (max-width: 480px) {
        font-size: 12px;
    }
`;

export const LoadingContainer = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 100px 0;

    @media (max-width: 768px) {
        padding: 60px 0;
    }

    @media (max-width: 480px) {
        padding: 40px 0;
    }
`;

